var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPause = function SvgPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 18,
    fill: "none",
    viewBox: "0 0 17 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M1 3.29A2.29 2.29 0 0 1 3.29 1v0a2.29 2.29 0 0 1 2.28 2.29V14.7A2.29 2.29 0 0 1 3.3 17v0A2.29 2.29 0 0 1 1 14.71V3.3ZM11.29 3.29A2.29 2.29 0 0 1 13.57 1v0a2.29 2.29 0 0 1 2.29 2.29V14.7a2.29 2.29 0 0 1-2.29 2.3v0a2.29 2.29 0 0 1-2.28-2.29V3.3Z",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgPause;